export const visibilityData = [
  {
    quarter: "Summer 2018",
    pm10: 23.47,
    neph: 0.23,
  },
  {
    quarter: "Autumn 2018",
    pm10: 21.97,
    neph: 0.36,
  },
  {
    quarter: "Winter 2018",
    pm10: 19.83,
    neph: 0.27,
  },
  {
    quarter: "Spring 2018",
    pm10: 21.07,
    neph: 0.23,
  },
  {
    quarter: "Summer 2019",
    pm10: 23.83,
    neph: 0.3,
  },
  {
    quarter: "Autumn 2019",
    pm10: 18.2,
    neph: 0.3,
  },
  {
    quarter: "Winter 2019",
    pm10: 18.5,
    neph: 0.24,
  },
  {
    quarter: "Spring 2019",
    pm10: 41.3,
    neph: 0.85,
  },
  {
    quarter: "Summer 2020",
    pm10: 27.07,
    neph: 0.46,
  },
  {
    quarter: "Autumn 2020",
    pm10: 15.63,
    neph: 0.26,
  },
  {
    quarter: "Winter 2020",
    pm10: 15.23,
    neph: 0.25,
  },
  {
    quarter: "Spring 2020",
    pm10: 19.2,
    neph: 0.2,
  },
  {
    quarter: "Summer 2021",
    pm10: 18.47,
    neph: 0.17,
  },
  {
    quarter: "Autumn 2021",
    pm10: 18.2,
    neph: 0.28,
  },
  {
    quarter: "Winter 2021",
    pm10: 14.57,
    neph: 0.23,
  },
  {
    quarter: "Spring 2021",
    pm10: 16.93,
    neph: 0.19,
  },
  {
    quarter: "Summer 2022",
    pm10: 16.53,
    neph: 0.16,
  },
  {
    quarter: "Autumn 2022",
    pm10: 13.8,
    neph: 0.19,
  },
  {
    quarter: "Winter 2022",
    pm10: 11.87,
    neph: 0.16,
  },
  {
    quarter: "Spring 2022",
    pm10: 14.33,
    neph: 0.14,
  },
  {
    quarter: "Summer 2023",
    pm10: 16.63,
    neph: 0.19,
  },
  {
    quarter: "Autumn 2023",
    pm10: 15.53,
    neph: 0.22,
  },
]
